function requestAPI(token, data) {
  return fetch(`${process.env.REACT_APP_AGENT_URL}review-product`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? 'Bearer ' + token : ''
    },
    body: JSON.stringify(data)
  }).then((res) => res.json())
}

export default function actionSaveReview(dataParam) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'SAVE_REVIEW_BEGIN'
      })

      const token = (getState().auth && getState().auth.authenticate)
        ? getState().auth.authenticate.token
        : localStorage.getItem('nabawi-token')

      const result = await requestAPI(token, dataParam)

      if (!result.status) {
        handleErrors(dispatch, result)
        return result
      }

      dispatch({
        type: 'SAVE_REVIEW_SUCCESS',
        payload: result.data
      })
      return result
    } catch (err) {
      handleErrors(dispatch, err)
      throw err
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({
    type: 'SAVE_REVIEW_FAILURE',
    error: error
  })
}
